import {dataClient} from 'data-client'
import axios from 'axios';

const apiAxios = axios.create({
    baseURL: 'https://coaz.org:8085',
    withCredentials: true,
});

const client = dataClient({
    axios:apiAxios,
    authAxios:apiAxios,
    service:'auth',
    authService:'auth',
    logoutUrl:'/_login'});

/* const apiAxios = axios.create({
    baseURL: 'http://localhost:8080',
    withCredentials: true,
});

const client = dataClient({
    axios:apiAxios,
    authAxios:apiAxios,
    logoutUrl:`/_login?successUrl=${window.location.href}`}); */

export default client;